import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

const useAuthGuard = () => {
  const shouldReset = useSelector((state) => state.account.shouldReset);
  const access_token = useSelector((state) => state.auth.access_token);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (!access_token) {
      // Redirect to login page
      history.replace({
        pathname: "/connect",
        state: { from: location },
      });
    }

    if (shouldReset && location.pathname !== '/change-password') {
      // Redirect to password change page
      history.replace({
        pathname: "/change-password",
        state: { from: location },
      });
    }
  }, [access_token, shouldReset, location, history]);
};

export default useAuthGuard;
